import * as yup from "yup"
import type { Media } from "../../types"

export function initialValuesMedia(media?: Media | undefined) {
  if (media) {
    return media
  }
  return {
    title: "",
    description: "",
    media_file: null,
  }
}

export function validationSchemaMedia() {
  return yup.object().shape({
    media_file: yup.mixed().required("Campo obbligatorio"),
  })
}
